<template>
  <div class="wrappNextYearCompetition">
    <div class="title">{{ $t( generateTitle(data.cmp_age)) }}</div>
    <div class="text">"{{ data.cmp_theme }}"</div>
    <ul>
      <li>
        {{ $t('competitions.tr.termsConditions')}}
        <router-link
          :to="{
            name: 'CompetitionRules',
            params: { id: data.cmp_id }
          }"
          >{{ $t('competitions.tr.here')}}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'nextCompetition',
  props: {
    data: {}
  },
  methods: {
    generateTitle (num) {
      switch (num) {
        case 1:
          return 'competitions.main.preschoolAge'
          break
        case 2:
          return 'competitions.main.elementarySchool'
          break
        case 3:
          return 'competitions.main.secondarySchools'
          break
        case 4:
          return 'competitions.main.all_age'
          break
        default:
           'competitions.main.all_age'
      }
    }
  }
}
</script>

<style lang="scss">
.wrappNextYearCompetition {
  box-sizing: border-box;

  width: 100%;
  padding-right: 0px;
  padding-bottom: 34px;
  // margin-right: 15px;
  // background: rgba(165, 42, 42, 0.205);
  border-right: none;
  border-bottom: 2px solid #d9d9d9;
  margin-bottom: 35px;

  .title {
    font-weight: 600;
    font-size: 22px;
    letter-spacing: 0.06em;
    color: rgba(71, 71, 71, 0.96);
    margin-bottom: 20px;
  }
  .text {
    font-weight: 400;
    font-size: 22px;
    color: rgba(100, 100, 100, 0.96);
  }
  ul {
    padding-left: 20px;
    li {
      font-style: normal;
      font-weight: 400;
      font-size: 19px;
      line-height: 194.9%;
      color: rgba(100, 100, 100, 0.96);

      a {
        color: $main-text-color;
      }
    }
  }
}
</style>
